<div class="container">
  <div class="modal-header">
    <h2>{{ 'education_modal.title' | translate }}</h2>
  </div>

  <div class="education-fields">
    <app-input [size]="InputSize.LARGER" [withNoIcon]="true"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="education.education"
               [placeholder]="'education_modal.degree_placeholder' | translate"></app-input>

    <app-input [size]="InputSize.LARGER" [withNoIcon]="true"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="education.organization"
               [placeholder]="'education_modal.institution_placeholder' | translate"></app-input>

    <app-input [size]="InputSize.LARGER" [withNoIcon]="true"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="education.location"
               [placeholder]="'education_modal.location_placeholder' | translate"></app-input>

    <app-input [size]="InputSize.LARGER" [withNoIcon]="true" type="date"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="education.startDate"
               [placeholder]="'education_modal.start_date_placeholder' | translate"></app-input>

    <app-input [size]="InputSize.LARGER" [withNoIcon]="true" type="date"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="education.completionDate"
               [placeholder]="'education_modal.completion_date_placeholder' | translate"></app-input>
  </div>

  <div *ngIf="validationErrors.requiredFields" class="error-msg">
    {{ 'education_modal.error_required_fields' | translate }}
  </div>
  <div *ngIf="validationErrors.startDateFuture" class="error-msg">
    {{ 'education_modal.error_start_date_past' | translate }}
  </div>
  <div *ngIf="validationErrors.invalidRange" class="error-msg">
    {{ 'education_modal.error_invalid_range' | translate }}
  </div>


  <div class="modal-actions">
    <div class="button-group">
      <app-button (click)="cancel()" [label]="'shared.cancel' | translate"
                  [state]="ButtonState.REGULAR" [size]="ButtonSize.LARGE"
                  [type]="ButtonType.SECONDARY"></app-button>
      <app-button (click)="save()" [label]="'shared.save' | translate" [size]="ButtonSize.LARGE"
                  [state]="isInvalid ? ButtonState.DISABLED : ButtonState.REGULAR"
                  [type]="ButtonType.PRIMARY"></app-button>
    </div>
  </div>
</div>
